import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './EditorHeader.module.scss'

const EditorHeader = ({ eyebrow, action }) => (
  <div className={classNames('d-flex align-items-center justify-content-between', classes.header)}>
    <span className={classes.eyebrow}>{eyebrow}</span>
    {action}
  </div>
)

EditorHeader.propTypes = {
  eyebrow: PropTypes.string.isRequired,
  action: PropTypes.node,
}

export default EditorHeader
